import { render, staticRenderFns } from "./TaxRatesList.vue?vue&type=template&id=4f2cc48c&scoped=true&lang=pug"
import script from "./TaxRatesList.vue?vue&type=script&lang=ts"
export * from "./TaxRatesList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./TaxRatesList.vue?vue&type=style&index=0&id=4f2cc48c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f2cc48c",
  null
  ,true
)

export default component.exports